import { isEmpty } from "lodash-es"
import qs from "qs"

export interface Router {
  pathname: string
  query: Record<string, string | string[] | undefined>
  push: (url: string) => void
  replace: (url: string) => void
  back: () => void
  forward: () => void
}

export const pushWithQueryParams = (router: Router, newRoute: string) => {
  const existingQueryParams = router.query
  const newUrl = isEmpty(existingQueryParams) ? newRoute : `${newRoute}?${qs.stringify(existingQueryParams)}`

  router.push(newUrl)
}

export const getRouteWithQueryParams = (queryParams: Record<string, string>, newRoute: string) => {
  const newUrl = isEmpty(queryParams) ? newRoute : `${newRoute}?${qs.stringify(queryParams)}`

  return newUrl
}

/**
 * TanStack Router's `ParsedLocation.search` is the **parsed search object** — `{}` when there
 * are no params, and therefore always truthy. String-concatenating it (the shape the PostHog
 * Next.js tutorial suggests, where `useSearchParams()` is string-able) yields `[object Object]`
 * and silently corrupts every `$pageview`. `searchStr` is the serialized form, already
 * `?`-prefixed or empty — always build analytics URLs from that.
 *
 * The param type deliberately requires `searchStr`, so passing a raw `location.search` object
 * back in is a type error rather than a stringification bug.
 */
export interface IPageviewLocation {
  pathname: string
  searchStr: string
}

export const buildPageviewUrl = (origin: string, location: IPageviewLocation): string =>
  `${origin}${location.pathname}${location.searchStr}`
